const { ComponentBox } = require("./components/_box");
const { ComponentButtonBackToTop } = require("./components/_button-back-to-top");
const { ComponentDownloads } = require("./components/_download");
const { ComponentFancySlider } = require("./components/_fancy-slider");
const { ComponentFAQLexicon } = require("./components/_faq-lexicon");
const { ComponentForm } = require("./components/_form");
const { ComponentGrid } = require("./components/_grid");
const { ComponentMember } = require("./components/_member");
const { ComponentMenu } = require("./components/_menu");
const { ComponentMetodology } = require("./components/_metodology");
const { ComponentNewsletterPopup } = require("./components/_newsletter-popup");
const { ComponentVideo } = require("./components/_video");
const { ComponentSignatures } = require("./components/_signatures");
const { ComponentBanners } = require("./components/_banners");

$(document).ready(function() {
  ComponentMenu();
  ComponentButtonBackToTop();

  ComponentBox();
  ComponentMember();
  ComponentGrid();
  ComponentMetodology();
  ComponentForm();
  ComponentDownloads();
  ComponentFancySlider();
  ComponentFAQLexicon();
  ComponentVideo();
  ComponentSignatures();
  ComponentBanners();
  ComponentNewsletterPopup();
});
